import { Component } from 'react'
import queryString from 'query-string'

class Page extends Component {

    initialize = () => {
        const script = document.createElement("script")
        script.src = "./js/agency.js"
        script.async = true
        document.body.appendChild(script)
        this.evalTerm();
    }

    evalTerm = () => {
        if (this.props.location && this.props.location.search) {
            const values = queryString.parse(this.props.location.search)
            const inner = values.inner;
            if (inner !== 'undefined') document.getElementById(inner).scrollIntoView();
        }
    }

}

export default Page;